import LocalisedLoadingProvider from "components/LocalisedLoadingProvider";
import { Suspense, lazy, useEffect } from "react";
import { Route } from "react-router-dom";
import { Routes } from "components/Sentry/Routes";
import DashboardProvider from "./providers/DashboardProvider";
import DashboardOptionsProvider from "./providers/DashboardOptionsProvider";
import LoadingFallback from "./DashboardsHome/DashboardWidgetFactory/components/WidgetStatusHandler/LoadingFallback";
import { useTranslation } from "react-i18next";
import ThemeProvider2024 from "components/MuiThemeProvider/ThemeProvider2024";
import { ExercisesWithOneRepMaxMetricProvider } from "providers/ExercisesWithOneRepMaxMetricProvider";
import useDashboardVelocityHotspot from "hooks/useDashboardVelocityHotspot";

const DashboardsHome = lazy(() => import("./DashboardsHome"));

export interface DashboardsProps {}

function Dashboards(props: DashboardsProps) {
  const { t } = useTranslation();
  const dashboardHotspot = useDashboardVelocityHotspot();

  useEffect(() => {
    if (dashboardHotspot.open) dashboardHotspot.dismiss();
  }, [dashboardHotspot]);

  return (
    <ExercisesWithOneRepMaxMetricProvider>
      {/* 
        TODO: ThemeProvider should be moved to the root of the app.
        We are using it here to avoid breaking changes in
        the existing codebase.
      */}
      <ThemeProvider2024>
        <LocalisedLoadingProvider>
          <DashboardProvider>
            <DashboardOptionsProvider>
              <Routes>
                <Route
                  path={"*"}
                  element={
                    <Suspense
                      fallback={
                        <LoadingFallback animation="pulse" message={t("dashboard.no_data_wrapper_loading_message")} />
                      }
                    >
                      <DashboardsHome />
                    </Suspense>
                  }
                />
              </Routes>
            </DashboardOptionsProvider>
          </DashboardProvider>
        </LocalisedLoadingProvider>
      </ThemeProvider2024>
    </ExercisesWithOneRepMaxMetricProvider>
  );
}

export default Dashboards;
